import styled from "styled-components";
import { FormControl, Select, InputLabel, TextField, MenuItem } from '@mui/material';
import { useGetInoutHistSel, useGetInoutSel } from "../../../interface/inout";

import React, { useState, useEffect } from 'react';
import CommonDataGrid from "../../common/CommonDataGrid";
import moment from 'moment';
import Button from "../../common/Button";
import { Row } from "../../../styles/common";
import Tab from './Tab';
import { useQuery } from "react-query";
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import NaviText from "../../backoffice/common/NaviText";
import theme from "../../../styles/theme";
import { IOT_TP } from "../../common/constants";

const MainWrap = styled.div`
    width: 100%;
    // padding: 1rem;
    display: flex;
    gap: 0.8rem;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .subTab {
        // padding: 1rem 0rem;
        width: 100%;
        display: flex;
        gap: 0.8rem;
        align-items: center;
        justify-content: flex-start;
    }
    .pannel {
        margin: 0rem 1rem 0rem 1rem;
        width: calc(100% - 2rem);
        // overflow:auto;
        .complete {
            background: ${theme.color.primary.pupple2};
        }
    }
    .gridPannel {
        margin: 0rem 1rem 0rem 1rem;
        width: calc(100% - 2rem);
        overflow:auto;
        .complete {
            background: ${theme.color.primary.pupple2};
        }
    }
    
`;

const columns = [
    { field: 'id', headerName: '순번', width:60 },
    { field: 'lot_no', headerName: '표기번호', width: 100 },
    { field: 'o_reg_dt', headerName: '반출일', width:145 },
    { field: 'o_reg_nm', headerName: '반출자', width:100 },
    { field: 'i_reg_dt', headerName: '반입일', width:145 },
    { field: 'i_reg_nm', headerName: '반입자', width:100 },
    { field: 'i_ret_stnm', headerName: '반입상태', width:100 },
    { field: 'tno', headerName: '자산번호', width:140},
    { field: 'cat_nm', headerName: '분류', width: 100 },
    // { field: 'o_ret_stnm', headerName: '반출상태', width:80 },
    { field: 'model_nm', headerName: '모델명', width:140 },
];

const MInoutMain = (props) => {

    const param = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [naviText, setNaviTest] = useState();
    const [sno, setSno] = useState((location.state && location.state.sno) ? parseInt(location.state.sno,10) : -1);
    const [inoutInfo, setInoutInfo] = useState({});

    const {data : { tabId } } = useQuery('TAB',{initialData:{tabId:0}});
    const { data: inoutList} = useGetInoutSel({is_ing:1,iot_tp:param.iot_tp});
    const { data, isLoading, refetch: inoutHistRefetch } = useGetInoutHistSel({sno:sno});

    const [list, setList] = useState([]);

    useEffect(()=>{
        switch(param.iot_tp){
            case IOT_TP.SEARCH:
                setNaviTest('조사설치');
                break;
            case IOT_TP.FIX:
                setNaviTest('장비수리');
                break;
            case IOT_TP.RENT:
                setNaviTest('장비임대');
                break;
            case IOT_TP.ETC:
                setNaviTest('기타');
                break;
            default :
                setNaviTest('전체')
                break;
        }
    },[param.iot_tp])

    useEffect(()=>{
        setInoutInfo(inoutList && inoutList.find(item=>item.sno === sno));
        inoutHistRefetch();
    },[sno, inoutList])

    useEffect(()=>{
        if(data){
            setList(
                data.map((item,index)=>(
                    {
                        ...item,
                        id: (index+1),
                        o_reg_dt: moment(item.o_reg_dt).format('YYYY/MM/DD HH:mm'),
                        i_reg_dt: (item.i_reg_dt && item.i_reg_dt!== null) ? moment(item.i_reg_dt).format('YYYY/MM/DD HH:mm') : '',
                    }
                    )));
        }else{
            setList([])
        }
    },[data])

    const rowStatus = (param) => {
        return param.row.i_seq !== null && 'complete'
    }

    return (
        <MainWrap>
            <div style={{marginBottom:'-1rem',padding:'0 1rem'}}>
                <NaviText target={[{text:'HOME',url:'/'}, {text:naviText}]} />
            </div>
            <div className="pannel" style={{marginTop:0}}>
                <FormControl style={{width:'100%'}} size='small'>
                    <InputLabel id='iotTp-label'>과업명</InputLabel>
                    <Select label="과업명" labelId='iotTp-label' size='small' value={sno} >
                        {inoutList && inoutList.map((item,index)=>{
                            return <MenuItem 
                                        key={index} 
                                        value={item.sno} 
                                        onClick={()=>setSno(item.sno)}
                                    >
                                        {item.iot_nm}
                                    </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>
            
            {inoutInfo &&
                <React.Fragment>
                    <Tab />
                    {tabId ===0 && 
                    <div className='pannel' style={{marginTop:0}}>
                        <Row style={{display:'grid',width:'100%',gap:'8px',gridTemplateColumns:'1fr 1fr 1fr'}}>
                            <TextField
                                id='iot_tpnm'
                                label='반출입유형'
                                size='small'
                                disabled={true}
                                InputLabelProps={{shrink:true}} 
                                // defaultValue={pItem[0].isp_nm}
                                value={inoutInfo && inoutInfo.iot_tpnm}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='reg_dt'
                                label='등록자'
                                size='small'
                                disabled
                                InputLabelProps={{shrink:true}} 
                                // defaultValue={pItem[0].isp_nm}
                                value={inoutInfo && inoutInfo.reg_nm}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='reg_dt'
                                label='등록일'
                                size='small'
                                disabled
                                // type='date'
                                InputLabelProps={{shrink:true}} 
                                // defaultValue={pItem[0].isp_nm}
                                value={inoutInfo && moment(inoutInfo.reg_dt).format('YYYY-MM-DD')}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        </Row>
                        <Row>
                            <TextField
                                id='contents' 
                                label='조사내용' 
                                fullWidth 
                                multiline 
                                disabled
                                rows={4} 
                                size='small' 
                                value={inoutInfo && inoutInfo.contents}
                            />
                        </Row>
                        <Row>
                            <TextField
                                id='descr' 
                                label='비고' 
                                fullWidth 
                                multiline
                                disabled 
                                rows={4} 
                                size='small' 
                                value={inoutInfo && inoutInfo.descr}
                            />
                        </Row>
                    </div>
                    }
                    {tabId === 1 &&
                        <div className="gridPannel">
                            <Row>
                                전체 : {list.length}
                            </Row>
                        <CommonDataGrid
                            isLoading={isLoading}
                            list={list}
                            columns={columns}
                            // showCount={10}
                            getRowClassName={rowStatus}
                            autoHeight={true}
                            // onRowClick={(e)=>{setTargetSelect(e.row);setItemOpen(true)}}
                        />
                        </div>
                    }
                    <Row style={{display:'grid',width:'100%',padding:'0 1rem',gap:'8px',gridTemplateColumns:'1fr 1fr'}}>
                        <Button style={{margin:0,width:'100%'}} onClick={()=>navigate('/inout/'+inoutInfo.sno+'/out')}>반출<img src={'/images/ic_qrcode.svg'}  alt='' /></Button>
                        <Button style={{margin:0,width:'100%'}} onClick={()=>navigate('/inout/'+inoutInfo.sno+'/in')}>반입<img src={'/images/ic_qrcode.svg'}  alt='' /></Button>
                    </Row>
                </React.Fragment>
            }
        </MainWrap>
    )
}

export default MInoutMain;